export default class ServiceProvider {
    constructor(whispererSearchService, searchService) {
        this._whispererSearchService = whispererSearchService;
        this._searchService = searchService;
    }
    get whispererSearchService() {
        return this._whispererSearchService;
    }
    get searchService() {
        return this._searchService;
    }
}
